import { Component, OnInit } from '@angular/core';
import { Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

//import{PublicNavBarComponent} from '../PublicNavBar/publicnavbar.component';

@Component({
  selector: 'app-termsofuse',
  templateUrl: './termsofuse.component.html'
})
export class TermsofuseComponent implements OnInit {

  constructor(private router: Router,private httpClient: HttpClient){
    localStorage.setItem("is_cuurent_nav_aem","y");
  }


  products: any = [];


  ngOnInit(){
    this.httpClient.get(environment.getAemurl()+"/static_content/terms-of-use-page.json").subscribe(data =>{
      //console.log(data);
      this.products = data;

     
     
    })
  }

  ngAfterViewChecked(){
    document.querySelectorAll('h1')
    .forEach((input) => {
      var att = document.createAttribute("class");       // Create a "class" attribute
      att.value = "aem-h1";                           // Set the value of the class attribute
      input.setAttributeNode(att); 

       }
     
    ); //end for h1


    document.querySelectorAll('h2')
    .forEach((input) => {
      var att = document.createAttribute("class");       // Create a "class" attribute
      att.value = "aem-h2";                           // Set the value of the class attribute
      input.setAttributeNode(att); 

       }
     
    ); //end for h2

    document.querySelectorAll('h3')
    .forEach((input) => {
      var att = document.createAttribute("class");       // Create a "class" attribute
      att.value = "aem-h3";                           // Set the value of the class attribute
      input.setAttributeNode(att); 

       }
     
    ); //end for h3


  


}




}
